/*eslint consistent-this:0*/

define(['angular', 'mod', 'lodash', 'common/urltemplate', 'angular-ui-router'], function(angular, mod, _, urltemplate) {
var m = require('am');

m.factory('$api', ['$http', '$q', 'config', '$location', '$rootScope', '$state',
 function($http, $q, config, $location, $rootScope, $state) {
    var needs_refresh = false;
    var cache = new Cache();

    function flush() {
        needs_refresh = false;
        cache.clear();
        console.log('Refreshing api data');
    }
    function force_refresh() {
        needs_refresh = true;
    }

    $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
        if (needs_refresh) {
            event.preventDefault();
            flush();
            $state.go(toState, toParams, {reload: true});
        }
    });

    // TODO: Implement cache expiration
    function Cache(base) {
        this._urls = {};
    }
    _.extend(Cache.prototype, {
        get: function(url) {
            url = normalize_url(url);
            return this._urls[url];
        },
        set: function(resource, url) {
            url = url && normalize_url(url);
            var urls = this._urls;
            if (!_.isUndefined(url)) {
                urls[url] = resource;
            }
            function add(resource) {
                if (resource.self && resource.self.href) {
                    url = normalize_url(resource.self.href);
                }
                urls[url] = resource;
            }
            if (resource.then) {
                resource.then(add);
            } else {
                add(resource);
            }
            return resource;
        },
        remove: function(url) {
            url = normalize_url(url);
            delete this._urls[url];
        },
        clear: function() {
            this._urls = {};
        }
    });

    var host = $location.protocol() + '://' + $location.host();
    if ($location.port()) {
        host += ':' + $location.port();
    }
    var bases = [
        config.api_url,
        host + config.api_url
    ];
    function normalize_url(url) {
        url = _.reduce(bases, function(url, base) {
            if (url.indexOf(base) === 0) {
                url = url.slice(base.length);
            }
            return url;
        }, url);
        if (url[0] === '/') {
            url = url.slice(1);
        }
        if (url.slice(-1) === '?') {
            url = url.slice(0, -1);
        }
        return url;
    }
    function update_cached(url, data) {
        var obj = cache.get(url);
        if (obj && obj.then) {
            obj.then(function(res) {
                _.assign(res, data);
            });
        } else if (obj) {
            _.assign(obj, data);
        } else {
            return cache.set(data, url);
        }
        return obj;
    }
    function get(url, opt) {
        opt = _.defaults(opt || {}, {
            refresh: false
        });
        if (!opt.refresh) {
            var cached = cache.get(url);
            if (cached) {
                return $q.when(cached);
            }
        }
        return cache.set($http.get(url).then(function(r) {
            return new Resource(r.data, url);
        }), url);
    }

    function Link(data) {
        _.extend(this, data);
    }
    _.extend(Link.prototype, {
        $url: function $url() {
            return this.href;
        },
        $get: function $get(extra, opt) {
            var url = this.$url();
            if (!_.isUndefined(extra)) {
                var next = extra, remaining;
                if(_.isArray(extra) && extra.length > 0) {
                    next = extra[0];
                    remaining = extra.length > 2 ? extra.slice(1) : extra[1];
                }
                if (_.isObject(next)) {
                    return get(url, opt).then(function(resource) {
                        url = urltemplate(resource.self._template, next);
                        return get(url, opt).then(function(resource) {
                            if (remaining) {
                                return resource.$get(remaining);
                            }
                            return resource;
                        });
                    });
                } else if (this[next]) {
                    return this[next].$get(remaining);
                }
                return get(url).then(function(resource) {
                    return resource[next].$get(remaining);
                });
            }
            return get(url, opt);
        },
        $put: function $put(data, opt) {
            opt = opt || {};
            _.defaults(opt, {
                needs_refresh: true,
                update_cached: true
            });
            needs_refresh = opt.needs_refresh;
            var url = this.$url();
            return $http.put(url, data).then(function(r) {
                var new_url;
                try {
                    new_url = r.data._links.self.href;
                } catch(e) {
                    new_url = url;
                }
                if (_.isUndefined(cache.get(new_url))) {
                    return cache.set(new Resource(r.data), new_url);
                }
                if (opt.update_cached) {
                    return update_cached(new_url, r.data);
                }
                return cache.get(new_url);
            });
        },
        $post: function $post(data, opt) {
            opt = _.defaults(opt || {}, {
                needs_refresh: true
            });
            if (opt.needs_refresh) needs_refresh = true;
            return $http.post(this.$url(), data).then(function(r) {
                return cache.set(new Resource(r.data));
            });
        },
        $delete: function $delete(data, opt) {
            needs_refresh = true;
            return $http.delete(this.$url()).then(function(r) {
                return r;
            });
        },
        $unlink: function $unlink(data, opt) {
            needs_refresh = true;
            var req = {
                method: 'UNLINK',
                url: this.$url(),
                data: data,
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return $http(req);
        },
        $link: function $link(data, opt) {
            needs_refresh = true;
            var req = {
                method: 'LINK',
                url: this.$url(),
                data: data,
                headers: {
                    'Content-Type': 'application/json'
                }
            };
            return $http(req);
        },
        $patch: function $patch(data, opt) {
            needs_refresh = true;
            var url = this.$url(),
                link = this,
                req = {
                    method: 'PATCH',
                    url: url,
                    data: data,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
            return $http(req).then(function(r) {
                update_cached(url, data);
                _.assign(link, data);
                return r;
            });
        }
    });

    function bind_functions(target, source) {
        _(source).functions().each(function(name) {
            if (name[0] === '$') {
                if (name === '$put') {
                    target[name] = _.bindKey(source, name, target);
                } else {
                    target[name] = _.bindKey(source, name);
                }
            }
        });
    }

    function collection_get(vars) {
        /* jshint validthis:true */
        if (vars) {
            return get(urltemplate(this._template, vars));
        }
        return $q.all(_.map(this, function(cls) {
            return cls.$get();
        }));
    }

    function prop(obj, name, value) {
        Object.defineProperty(obj, name, {value: value});
    }

    function Resource(data, url) {
        _.extend(this, _.omit(data, ['_links', '_embedded']));

        var res = this,
            templated = {};

        _.each(data._links || [], function(item, name) {
            var template = data._links.templates && data._links.templates[name];
            if (_.isArray(item)) {
                prop(res, name, _.map(item, function(link) {
                    return new Link(link);
                }));
                if (template) {
                    res[name]._template = template;
                }
                res[name].$get = collection_get;
            } else {
                var link = new Link(item);
                if (template) {
                    link._template = template;
                }
                prop(res, name, link);
            }
        });
        bind_functions(this, this.self || new Link({href: url}));

        _.each(data._embedded || [], function(item, name) {
            if (_.isArray(item)) {
                _.each(item, function(subitem) {
                    cache.set(new Resource(subitem));
                });
            } else {
                cache.set(new Resource(item));
            }
        });
    }

    return {
        get: function(url) {
            return get(url || config.api_url);
        },
        flush: flush,
        force_refresh: force_refresh
    };
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/api.js
 **/